import { useFireAIAnalyticsEvent } from '../utils';

// This is done to support mocking in tests
// eslint-disable-next-line @atlaskit/editor/no-re-export
export const _useFireAIAnalyticsEvent = useFireAIAnalyticsEvent;
